import invariant from "invariant";
import { colorAndOpacityToRGBA, colorIsAdaptedForForeground } from "../Utils/colorUtils";

const dot = (color = "transparent") => ({
  alignItems: "center",
  display: "flex",

  ":before": {
    backgroundColor: color,
    borderRadius: 10,
    content: "\" \"",
    display: "block",
    marginRight: 8,
    height: 10,
    width: 10
  }
});

const calculateBackgroundColor = (color, { isSelected, isFocused, isDisabled }) => {
  if (isDisabled || (!isSelected && !isFocused)) return;
  else if (isSelected) return `${color} !important`;
  else if (isFocused) return `${colorAndOpacityToRGBA(color, 0.1)} !important`;
};

const calculateForegroundColor = (color, foregroundColor, { isSelected, isDisabled }) => {
  if (isDisabled) {
    return "#ccc !important";
  } else if (isSelected) {
    if (foregroundColor) return `${foregroundColor} !important`;
    else if (colorIsAdaptedForForeground(color)) return "white !important";
    else return "black !important";
  }
};

const calculateActiveBackgroundColor = (color, { isSelected, isDisabled }) => {
  if (isDisabled) return;
  else if (isSelected) return `${color} !important`;
  else `${colorAndOpacityToRGBA(color, 0.3)} !important`;
};

// This is borrowed from the `react-select` documentation and allows us to force the
// display of the options' provided colors in the dropdown, and a colored dot when
// selected in the input placeholder.
//
export const selectOptionsWithColorStyles = {
  control: styles => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { data, isSelected, isFocused, isDisabled }) => {
    const { color: optionColor, foregroundColor } = data;
    const optionState = { isSelected, isFocused, isDisabled };

    invariant(
      optionColor,
      `You must provide a color property to each of your Select options when using 
       selectOptionsWithColorStyles in the Select styles property.
      `
    );

    const backgroundColor = calculateBackgroundColor(optionColor, optionState);
    const color = calculateForegroundColor(optionColor, foregroundColor, optionState);
    const cursor = isDisabled ? "not-allowed" : "default";
    const activeBackgroundColor = calculateActiveBackgroundColor(
      optionColor,
      optionState
    );

    return {
      ...styles,
      backgroundColor,
      color,
      cursor,
      ...dot(optionColor),
      ":active": {
        ...styles[":active"],
        backgroundColor: activeBackgroundColor
      }
    };
  },
  input: styles => ({ ...styles, ...dot() }),
  placeholder: styles => ({ ...styles, ...dot("#ccc") }),
  singleValue: (styles, { data: { color: optionColor } }) => ({
    ...styles,
    ...dot(optionColor)
  })
};
